import axios from "axios";
import {urlDomain } from '../config/constant'

const apiDomain = urlDomain();
// Customer Attribute API
export const customer_attributes = (glid,empid,ak, rptflag=0) => {
    if(glid){
        const apiUrl = `${apiDomain}/customerAttributes`;
        const requestData = { "in_glusr_usr_id" : `${glid}`, "rpt_flg": `${rptflag}`,empid : `${empid}`,AK : `${ak}`  };
        return axios.post(apiUrl, requestData)
    }
}


// Active and Inactive User
export const glmisccount = (glid, empid, ak) =>{
    const apiUrl = `${apiDomain}/glmisccount`;
    const requestData = { 
        inglusrusrid : `${glid}`,
        rptflag : "3",
        empid : `${empid}`,
        AK : `${ak}`
    };
    return axios.post(apiUrl, requestData)
}

export const showCategoriesCities = (glid,empid,ak, rptflag=0) => {
    if(glid){
        const apiUrl = `${apiDomain}/mcatLocDtls`;
        const requestData = {
            "in_glusr_usr_id": `${glid}`,
            "in_rpt_type": `${rptflag}`,
            "empid": `${empid}`,
            "AK": `${ak}`
        }
        return axios.post(apiUrl, requestData)
    }
}